import { render, staticRenderFns } from "./dial2.vue?vue&type=template&id=04e684a6&scoped=true"
import script from "./dial2.vue?vue&type=script&lang=js"
export * from "./dial2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e684a6",
  null
  
)

export default component.exports